<app-button class="btn-sso google" (onClick)="login()" [type]="eButtonType.GOOGLE" [buttonWidth]="'100%'">
    <img src="assets/img/sso/google/g-logo-2.png"/>
    <span>Sign in with Google</span>
</app-button>